import { Stack, Typography } from "@mui/material";
import { useGetPerson } from "api/queries/useGetPerson";
import useGetUser from "api/queries/useGetUser";
import dayjs from "dayjs";
import CenteredCircularProgress from "ui-library/CenteredCircularProgress";
import EmptyStateBox from "ui-library/EmptyStateBox";
import SettingsPageTitle from "ui-library/SettingsPageTitle";
import Breadcrumbs from "../Breadcrumbs";
import { DeleteProfile } from "./DeleteProfile";
import { UpdateEmail } from "./UpdateEmail";
import { UpdateProfile } from "./UpdateProfile";
import { sectionTitleSx } from "./common.styles";

const Index = () => {
	const { data: person, isLoading, isSuccess } = useGetPerson();
	const { data: user } = useGetUser();

	if (isLoading) {
		return (
			<>
				<Breadcrumbs />
				<CenteredCircularProgress />
			</>
		);
	}

	if (isSuccess && person) {
		return (
			<>
				<Breadcrumbs />
				<SettingsPageTitle>Profile Settings</SettingsPageTitle>
				<Typography sx={descriptionSx}>
					Review and edit your profile information and data associated with your
					account.
				</Typography>

				<Stack direction="row" spacing={1.5} alignItems="center">
					<Typography sx={sectionTitleSx}>Date Joined:</Typography>
					<Typography>{dayjs(user?.created).format("MMMM D, YYYY")}</Typography>
				</Stack>

				<UpdateEmail person={person} />
				<UpdateProfile person={person} />
				<DeleteProfile />
			</>
		);
	}

	return (
		<>
			<Breadcrumbs />
			<EmptyStateBox
				headerMessage="We were unable to load your profile settings"
				subMessage="Please refresh to try again"
			/>
		</>
	);
};

export default Index;

/** Style */

export const descriptionSx = {
	color: "text.secondary",
	marginBottom: "1.5rem",
};
